/*
 * NOTE DEPRICATED, only one user remains
 */
RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const DropdownItem = Marionette.ItemView.extend({
        tagName: 'li',
        behaviors: {
            MenuItem: {
                className: 'active',
                behaviorClass: App.behaviors.MenuItem
            }
        },
        template: '#toolbarDropdownItemTemplate',

        onShow: function () {
            const me = this;

            const tooltip = me.model.get('tooltip');

            if (tooltip) {
                me.$el.tooltip({
                    placement: 'left',
                    container: 'body',
                    title: tooltip
                });
            }
        }
    });

    // todo: make mixins a first class concept in Marionette/Backbone
    _.extend(DropdownItem.prototype, App.mixins.Navigable);

    const Dropdown = views.Dropdown = Marionette.CompositeView.extend({
        template: '#toolbarDropdownTemplate',
        className: 'dropdown inline-block',

        childEvents: {
            activated: 'onItemActivated'
        },

        modelEvents: {
            change: 'render'
        },

        childView: DropdownItem,
        childViewContainer: 'ul',

        initialize: function () {

            const me = this;
            const model = me.model;
            const collection = me.collection;

            if (!model.has('activeModel') && collection.length > 0) {

                model.set({
                    activeModel: collection.at(0)
                }, {
                    silent: true
                });
            }
        },

        childViewOptions: function (model, i) {

            const me = this;

            const activeModel = me.model.get('activeModel');

            const result = {
                active: (activeModel === model || !activeModel && i === 0),
                className: (model.get('disabled') ? 'disabled' : '')
            };

            return result;
        },

        serializeData: function () {

            const me = this;
            const activeModel = me.model.get('activeModel');

            return _.extend(me.model.toJSON(), {
                btnName: me.getOption('btnName'),
                btnClass: me.getOption('btnClass'),
                pullRight: me.getOption('pullRight') !== false,
                activeModel: activeModel.toJSON()
            });
        },

        onItemActivated: function (view) {

            const me = this;
            const activeModel = view.model;
            me.model.set({
                activeModel: activeModel
            });
            me.trackActivationEvent(activeModel);
            me.trigger('toolbar:action', {
                name: 'dropdown',
                active: activeModel
            });
        },

        trackActivationEvent: function (model) {

            const me = this;
            let modelOptions = null;
            const tracking = me.getOption('tracking');

            if (tracking) {

                modelOptions = (_.isFunction(tracking.modelToOptions) ?
                    tracking.modelToOptions(model) :
                    {});

                RivalIQ.execute('tracking:push:auth', tracking.metric,
                    _.extend({}, tracking.options, modelOptions));
            }
        }
    });

    Dropdown.getItemViewOptionsFromConfig = function (config) {

        const model = new Backbone.Model();

        const result = {
            model: model,
            btnName: config.btnName,
            btnClass: config.btnClass,
            tracking: _.result(config, 'tracking')
        };

        const items = _.result(config, 'items');

        if (items && items.length) {

            result.collection = new Backbone.Collection(items);

            const activeModel = result.collection.findWhere({
                active: true
            });

            if (activeModel) {

                model.set({
                    activeModel: activeModel
                });
            }
        }

        if (config.modelEvents) {

            Marionette.bindEntityEvents(model, model, config.modelEvents);
        }

        return result;
    };

});
